import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';

import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useModal } from '../../../../../../hooks/use-modal';
import { useSalesOrderIdContext } from '../../../../../context/sales-order-id-context-provider';
import { EditItemsModal } from '../../../../items/edit-items-modal/edit-items-modal';
import { useCanEditShipmentItems } from '../../../../items/items-table/empty-row/hooks/use-can-edit-shipment-items';
import { ADD_EDIT_SHIPMENT_ITEMS_ACTIONS, useTrackAddEditItemsShipmentAction } from '../../../../hooks/use-track-add-edit-items-action';
import {
  ORDER_DETAILS_ACTIONS,
  useTrackOrderDetailsAction,
} from '../../../../../modals/order-details-modal/event-tracking/use-track-order-details-action';

import messages from '../messages';

import style from '../shipment-items.module.less';
import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

const EditItemsButton = () => {
  const { open, close, isOpen } = useModal(false);
  const trackOrderDetailsAction = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.ADD_EDIT_SHIPMENT_ITEMS);
  const trackAddEditItemsShipmentOpen = useTrackAddEditItemsShipmentAction(ADD_EDIT_SHIPMENT_ITEMS_ACTIONS.OPEN);
  const trackAddEditItemsShipmentClose = useTrackAddEditItemsShipmentAction(ADD_EDIT_SHIPMENT_ITEMS_ACTIONS.CLOSE);

  const salesOrderId = useSalesOrderIdContext();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();

  const { canEditShipmentItems: canEditItems, fulfillmentPlanHasAdditionalItems } = useCanEditShipmentItems(
    fulfillmentPlanId,
    salesOrderId,
  );

  const onClick = useCallback(() => {
    open();
    trackOrderDetailsAction();
    trackAddEditItemsShipmentOpen({
      fulfillmentPlanId,
      hasAdditionalItems: fulfillmentPlanHasAdditionalItems,
    });
  }, [fulfillmentPlanHasAdditionalItems, fulfillmentPlanId, open, trackAddEditItemsShipmentOpen, trackOrderDetailsAction]);
  const onClose = useCallback(() => {
    trackAddEditItemsShipmentClose({
      fulfillmentPlanId,
      hasAdditionalItems: fulfillmentPlanHasAdditionalItems,
    });
    close();
  }, [close, fulfillmentPlanId, trackAddEditItemsShipmentClose, fulfillmentPlanHasAdditionalItems]);

  if (!canEditItems) {
    return null;
  }

  return (
    <>
      <Button className={buttonTextStyle['button-text']} onClick={onClick} theme='link'>
        <FormattedMessage
          {...messages.editButton}
          values={{
            icon: <FontAwesomeIcon className={style.icon} icon={faPen} />,
          }}
        />
      </Button>
      {isOpen && <EditItemsModal fulfillmentPlanId={fulfillmentPlanId} onClose={onClose} salesOrderId={salesOrderId} />}
    </>
  );
};

export default EditItemsButton;
